module.exports = __webpack_public_path__ + "img/title.d5cfba2c.png";